// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/produkte/gear-made-of-polyoxymethylene/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteGearMadeOfPolyoxymethyleneEN: PageEntry = {
  id: "example.produkte-zahnrad-aus-polyoxymethylen",
  locale: "en",
  slug: "produkte/gear-made-of-polyoxymethylene",
  seo: {
    title: "Gear made of polyoxymethylene | Dietz GmbH",
    description: "Gear made of polyoxymethylene (POM) for power transmission in the automotive sector.",
  },
  type: "post",
  h1: "Gear made of polyoxymethylene",
  intro: "Gear made of polyoxymethylene (POM) for power transmission in the automotive sector.",
  blocks: [
    { kind: "image", src: "/images/live/DTZ_Zahnrad_Polyoxymethylen.jpg", alt: "Gear made of polyoxymethylene", width: 800, height: 640 }
  ],
};
